import { useTranslation } from 'react-i18next';

import type { PlatformUserStatus } from '@nucleus-commerce/api-client/platform';

import { StatusDot, type StatusTone } from '@/shared/ui/status-dot';

const TONES: Record<PlatformUserStatus, StatusTone> = { active: 'success', disabled: 'muted' };

/** Status as a dot + word; colour alone never carries the meaning. */
export function UserStatusBadge({
  status,
  className,
}: {
  status: PlatformUserStatus;
  className?: string;
}) {
  const { t } = useTranslation('users');
  return (
    <StatusDot tone={TONES[status]} className={className} data-status={status}>
      {t(`status.${status}`)}
    </StatusDot>
  );
}
